import { Injectable, Type } from "@angular/core";
import { GetHelpHeroComponent } from "./get-help-hero/get-help-hero.component";
import { ComponentType } from "@app/component-type";

@Injectable({
  providedIn: "root",
})
export class HeroService {
  private readonly HERO_ITEMS: ReadonlyArray<ComponentType> = [GetHelpHeroComponent];

  constructor() {}

  getHero(): Type<ComponentType> {
    return this.HERO_ITEMS[0];
  }
}
